import React from "react"
import Password from "containers/auth/User_Account/Password"

function ManagePassword(props) {
  return <Password provider />
}

export default ManagePassword
